import { styled, Divider } from "@mui/material";

export const StyledDivider = styled(Divider)(({ theme }) => {
  return {
    borderColor: theme.palette.primary.light,
  };
});
